var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRewind(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 6.293a1 1 0 010 1.414L13.414 12l4.293 4.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 0z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MDcxIDYuMjkyODlDMTguMDk3NiA2LjY4MzQyIDE4LjA5NzYgNy4zMTY1OCAxNy43MDcxIDcuNzA3MTFMMTMuNDE0MiAxMkwxNy43MDcxIDE2LjI5MjlDMTguMDk3NiAxNi42ODM0IDE4LjA5NzYgMTcuMzE2NiAxNy43MDcxIDE3LjcwNzFDMTcuMzE2NiAxOC4wOTc2IDE2LjY4MzQgMTguMDk3NiAxNi4yOTI5IDE3LjcwNzFMMTEuMjkyOSAxMi43MDcxQzEwLjkwMjQgMTIuMzE2NiAxMC45MDI0IDExLjY4MzQgMTEuMjkyOSAxMS4yOTI5TDE2LjI5MjkgNi4yOTI4OUMxNi42ODM0IDUuOTAyMzcgMTcuMzE2NiA1LjkwMjM3IDE3LjcwNzEgNi4yOTI4OVoiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjciIHk9IjUiIHdpZHRoPSIyIiBoZWlnaHQ9IjE0IiByeD0iMSIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };